window.GreenBadgeAssistantRules = {
  version: 'v3.2',
  germany: {
    decisionByEmissionPrefix: {
      passenger: ['04'],
      heavy: ['06']
    }
  },
  germanEmissionKeys: {
    passengerDiesel: {
      green: ['32','33','38','39','43','53','54','55','56','57','58','59','60','61','62','63','64','65','66','67','68','69','70','73','74','75'],
      yellow: ['30','31','36','37','42','44','45','46','47','48','49','50','51','52','72'],
      red: ['25','26','27','28','29','35','41','71'],
      none: ['00','01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','34','40','77','88']
    },
    heavyDiesel: {
      green: ['35','45','55','80','81','83','84','90','91'],
      yellow: ['34','44','54','70','71'],
      red: ['20','21','22','33','43','53','60','61']
    },
    alphanumericGreenSuffixes: {
      letterZeroFrom: 'A0',
      letterZeroTo: 'Y0',
      zRangeFrom: 'ZA',
      zRangeTo: 'ZF',
      singles: ['ZY','ZZ']
    }
  },
  foreignFirstRegistration: {
    dieselPassenger: { greenFrom: '2006-01-01' },
    dieselHeavy: { greenFrom: '2006-10-01' },
    petrol: { greenFrom: '1993-01-01' }
  },
  pmPassengerDiesel: {
    green: {
      pm5: '*',
      pm4: ['44','45','46','47','48','49','50','51','52','53','54','55','56','57','58','59','60','61','62','63','64','65','66','67','68','69','70'],
      pm3: ['32','33','38','39','43','53','54','55','56','57','58','59','60','61','62','63','64','65','66'],
      pm2: ['25','26','30','31','36','37','42','44','45','46','47','48','67','68','69','70'],
      pm1: ['27','49','50','51','52']
    },
    yellow: {
      pm1: ['14','16','18','21','22','25','26','27','34','35','40','41','71','77'],
      pm0: ['28','29']
    },
    red: {
      pm01: ['19','20','23','24'],
      pm0: ['14','16','18','21','22','34','40','77']
    }
  }
};
